function cleanBaseUrl(value: string): string {
  return value.replace(/\/+$/u, '')
}

const variables = import.meta.env

export const platformEnv = {
  ssoApiUrl: cleanBaseUrl(variables.VITE_SSO_API_BASE_URL || 'https://api-sso.hocnhe.com'),
  ssoFrontendUrl: cleanBaseUrl(variables.VITE_SSO_FRONTEND_URL || 'https://sso.hocnhe.com'),
  englishDictionaryApiUrl: cleanBaseUrl(variables.VITE_ENGLISH_DICTIONARY_API_BASE_URL || 'https://english-dictionary-api.hocnhe.com'),
  gatewayApiUrl: cleanBaseUrl(variables.VITE_GATEWAY_API_BASE_URL || 'https://ai.hocnhe.com'),
  googleClientId: variables.VITE_GOOGLE_CLIENT_ID || '541716939925-ftsktgf5culju42gl1qt96qvh39tf2p4.apps.googleusercontent.com',
  storageApiUrl: cleanBaseUrl(variables.VITE_STORAGE_API_BASE_URL || 'https://storage.hocnhe.com'),
} as const
